import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Auth/Login';
import YandexCallback from './pages/Auth/YandexCallback';
import GoogleCallback from './pages/Auth/GoogleCallback';
// Оболочка редактора. Старый Main.jsx (весь сайт робототехники: электроника,
// микроконтроллеры, схемы, рейтинги) на этом домене больше не используется —
// cad.* существует ради одного продукта.
import CadShell from './pages/CadShell/CadShell';

// Куда возвращать неавторизованного: вход единый, живёт в школе.
const SCHOOL_URL = 'https://minecraftia-school.ru/';

// Защищенный маршрут
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#00d4ff',
      }}>
        Загрузка...
      </div>
    );
  }

  // Не вошёл — показываем экран с кнопкой, а НЕ выкидываем молча.
  //
  // Своей формы входа у редактора быть не должно: домен cad.* — часть школы, а
  // не остаток сайта робототехники. Но и мгновенный redirect плох: человек не
  // понимает, почему его «выбросило», а если он попал сюда прямой ссылкой без
  // тикета — получается петля школа↔редактор. Поэтому объясняем и даём уйти
  // по клику: в школе он нажмёт «3D-редактор» и вернётся уже с тикетом.
  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100vh', gap: 18,
        background: '#1f2121', color: '#e8fbff',
        fontFamily: '"Exo 2", system-ui, sans-serif', padding: 20, textAlign: 'center',
      }}>
        <svg width="72" height="72" viewBox="0 0 64 64" fill="none" aria-hidden="true">
          <path d="M32 12 L52 23 L32 34 L12 23 Z" fill="#00d4ff"/>
          <path d="M12 23 L32 34 L32 54 L12 43 Z" fill="#0090b0"/>
          <path d="M52 23 L52 43 L32 54 L32 34 Z" fill="#006c86"/>
          <path d="M32 12 L52 23 L32 34 L12 23 Z M12 23 L12 43 L32 54 L52 43 L52 23 M32 34 L32 54"
                fill="none" stroke="#e8fbff" strokeWidth="2" strokeLinejoin="round"/>
        </svg>
        <h1 style={{ margin: 0, fontSize: 26 }}>Кубикон CAD</h1>
        <p style={{ margin: 0, maxWidth: 460, lineHeight: 1.5, color: '#9fc4cf' }}>
          Открой редактор из Майнкрафтии — в боковом меню, раздел «Ништяки».
          Тогда вход выполнится сам.
        </p>
        <a
          href={SCHOOL_URL}
          style={{
            marginTop: 6, padding: '14px 32px', borderRadius: 14,
            background: '#00d4ff', color: '#0d1b1e', fontWeight: 700,
            fontSize: 17, textDecoration: 'none',
          }}
        >
          Перейти в Майнкрафтию
        </a>
      </div>
    );
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Публичные роуты */}
          <Route path="/login" element={<Login />} />
          {/* OAuth callback'и (Yandex/Google редиректят сюда после авторизации). */}
          <Route path="/auth/yandex/callback" element={<YandexCallback />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />

          {/* Защищенные маршруты */}
          <Route
            path="/main/*"
            element={
              <ProtectedRoute>
                <CadShell />
              </ProtectedRoute>
            }
          />

          {/* Корень и неизвестные роуты ведут в редактор: домен cad.* — это
              теперь ровно один продукт, а не сайт с разделами. Гостя оттуда
              развернёт ProtectedRoute (в школу, а не на местную форму входа). */}
          <Route path="/" element={<Navigate to="/main/cad-editor" replace />} />
          <Route path="*" element={<Navigate to="/main/cad-editor" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;